import { useLingui } from "@lingui/react";
import { formatDate } from "@mobility-item-page/utilities";
import { useAppConfig } from "src/context/AppConfigProviderContext.tsx";
import FieldValuePair from "../FieldValuePair.tsx";
import type { SpecProps } from "./types.ts";

export const EuCheck = ({ euCheck }: SpecProps<"eu_check">) => {
  return (
    <>
      {euCheck?.last && <EuCheckLast last={euCheck.last} />}
      {euCheck?.next && <EuCheckNext next={euCheck.next} />}
    </>
  );
};

const EuCheckNext = ({ next }: { next: string }) => {
  const { i18n } = useLingui();
  const { locale } = useAppConfig();

  const field = i18n.t({
    id: "itemPageLayout.keyInfo.eu_check_next",
    message: "EU check next",
    comment: "Field for 'EU check next' in ad specification",
  });

  const value = formatDate(next, locale);

  return <FieldValuePair field={field} value={value} suppressHydrationWarning />;
};

export const EuCheckLast = ({ last }: { last: string }) => {
  const { i18n } = useLingui();
  const { locale } = useAppConfig();

  const field = i18n.t({
    id: "itemPageLayout.keyInfo.eu_check_last",
    message: "EU check last",
    comment: "Field for 'EU check last' in ad specification",
  });

  const value = formatDate(last, locale);

  return <FieldValuePair field={field} value={value} suppressHydrationWarning />;
};
